import getConfirmationWithVariables from '../../services/slate/getConfirmationWithVariables';
import { loadSlateContent } from '../../services/slate/load-slate-content';

export function getContent({ checkout, defaultConfirmation }) {
  if (checkout.redirectAfterPayment && checkout.redirectUrl) {
    if (checkout.customizeCheckoutConfirmation) {
      return {
        title: checkout.confirmationCheckoutTitle,
        message: checkout.confirmationCheckoutMessage,
      };
    }

    return {
      title: defaultConfirmation.title,
      message: `${defaultConfirmation.message}

      You will be redirected in a few seconds.`,
    };
  }

  if (checkout.customizeCheckoutConfirmation) {
    return {
      title: checkout.confirmationCheckoutTitle,
      message: checkout.confirmationCheckoutMessage,
    };
  }

  return defaultConfirmation;
}

export function getCheckoutConfirmation({ checkout, subscription, seller, email }) {
  const defaultConfirmation = {
    title: 'Subscription confirmed!',
    message: checkout.sendEmailConfirmation
      ? `Thanks for subscribing. You will receive an email confirmation shortly${
          email ? ` at ${email}` : '.'
        }`
      : 'Thanks for subscribing.',
  };

  const { title, message } = getContent({ checkout, defaultConfirmation });

  const { html, text } = parseConfirmationMessage(message, {
    subscription,
    seller,
    checkout,
  });

  return {
    title: subscription.livemode ? title : `[TEST] ${title}`,
    message: html || text,
    type: html ? 'html' : 'text',
  };
}

export function parseConfirmationMessage(message, { subscription, seller, checkout }) {
  try {
    const parsedValue = typeof message === 'string' ? JSON.parse(message) : message;
    const content = loadSlateContent(parsedValue);

    return {
      html: getConfirmationWithVariables(content, subscription, seller, checkout),
    };
  } catch (e) {
    return {
      text: message,
    };
  }
}
